import React from 'react';

import viewIcon from 'images/icons/invite/view.svg';
import downloadIcon from 'images/icons/invite/download.svg';

import Tooltip from 'components/ui/Tooltip';

export default function Actions({ row, adminView }) {
  return (
    <>
      <div>
        {row.attributes.status !== 'draft' && (
        <>
          <a
            data-tip="View"
            href={row.attributes.invoice_link}
            className="mr5"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={viewIcon} />
          </a>
          <a
            data-tip="Download Invoice"
            href={row.attributes.invoice_pdf}
            className="mr5"
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={downloadIcon} />
          </a>
          <a
            data-tip="Download Members"
            href={row.attributes.members_report}
            rel="noopener noreferrer"
            target="_blank"
          >
            <img src={downloadIcon} />
          </a>
        </>
        )}
      </div>
      <Tooltip />
    </>
  );
}
